import React from 'react';
import cn from 'classnames';

interface Props {
  className?: string;
  articleHasBeenSponsored: boolean;
}

const SponsoredHeader = ({ className, articleHasBeenSponsored }: Props) => {
  if (!articleHasBeenSponsored) {
    return null;
  }

  return (
    <div
      className={cn('border-dashed border-b border-gray-600 mb-4', className)}
    >
      <h3 className='text-gray-500 uppercase text-center text py-2 font-heading'>
        Sponsored article
      </h3>
    </div>
  );
};

export default SponsoredHeader;
